import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { AuthProvider } from "./context/AuthContext";
import { GameProvider } from "./context/GameContext";
import { WebSocketProvider } from "../src/context/WebSockectContext";
import { TimerProvider } from "./context/TimerContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <WebSocketProvider>
  <AuthProvider>
    <GameProvider>
      <TimerProvider>
        <React.StrictMode>
          <BrowserRouter>
            <App />
          </BrowserRouter>
      </React.StrictMode>
      </TimerProvider>  
    </GameProvider>
  </AuthProvider>
  </WebSocketProvider>

);

requestAnimationFrame(() => {
  document.documentElement.classList.add("app-mounted");
  const startupLogo = document.getElementById("startup-logo");
  if (startupLogo) {
    setTimeout(() => {
      startupLogo.remove();
    }, 180);
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (!registration) return;

    const reloadOnControllerChange = () => {
      if (window.__huntexSwRefreshing) return;
      window.__huntexSwRefreshing = true;
      window.location.reload();
    };

    navigator.serviceWorker.addEventListener("controllerchange", reloadOnControllerChange);

    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
